import { ToggleButtonGroup as MuiToggleButtonGroup, ToggleButtonProps } from '@material-ui/lab'
import React, { forwardRef } from 'react'
import { ToggleButtonGroupProps } from './ToggleButtonGroupProps'
import { useToggleButtonGroupStyles } from './ToggleButtonGroupStyles'

export const ToggleButtonGroup = forwardRef<HTMLDivElement, ToggleButtonGroupProps>((props, ref) => {
  const { children, color = 'primary', ...muiProps } = props
  const classes = useToggleButtonGroupStyles(props)
  const childrenWithProps = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return null
    }
    return React.cloneElement(child as React.ReactElement<ToggleButtonProps>, { color })
  })

  return (
    <MuiToggleButtonGroup ref={ref} classes={{ root: classes.root }} {...muiProps}>
      {childrenWithProps}
    </MuiToggleButtonGroup>
  )
})

ToggleButtonGroup.displayName = 'ToggleButtonGroup'
